import { keepPreviousData, useQuery } from '@tanstack/react-query';

import {
  partnersAcquisitionApi,
  partnersAcquisitionApiKeys,
  type PartnerAcquisitionParams,
} from '@/api/routes/partners/partners.acquisition.api';

/** "Seus links": the partner's tracked links, what they brought in the period and the commissions. */
export const usePartnersReadAcquisition = (params: PartnerAcquisitionParams) => {
  return useQuery({
    queryKey: partnersAcquisitionApiKeys.read(params),
    queryFn: () => partnersAcquisitionApi.read(params).then((res) => res.data),
    placeholderData: keepPreviousData,
  });
};
